import { render } from "./addressManager.vue?vue&type=template&id=7d13e173&scoped=true"
import script from "./addressManager.vue?vue&type=script&lang=js"
export * from "./addressManager.vue?vue&type=script&lang=js"

import "./addressManager.vue?vue&type=style&index=0&id=7d13e173&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d13e173"]])